import { FilterViewType } from 'shared/types';

export const getPayloadForLocalState = (selectedFilter?: FilterViewType) => {
  const newFilter = {};
  selectedFilter?.conditions.forEach((condition) => {
    newFilter[condition.name] = condition;
  });
  return newFilter;
};
